import React, { useState, useEffect, useContext } from "react";
import { Outlet } from "react-router-dom";
import { AppBar, Toolbar, IconButton, Menu, MenuItem, Avatar, Drawer, Box, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import Logo from "../assets/logo.png"; // Ensure logo exists in src/assets/
import { Link } from "react-router-dom"; // Import Link from react-router
import LogoutIcon from "@mui/icons-material/Logout";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Brightness4Icon from "@mui/icons-material/Brightness4"; // 🌙 Moon (Dark Mode)
import Brightness7Icon from "@mui/icons-material/Brightness7"; // 🌞 Sun (Light Mode)
import { ThemeContext } from "../context/ThemeContext"; // Import ThemeContext
const drawerWidth = 240;

const Layout = () => {
    const { theme, toggleTheme } = useContext(ThemeContext); // Get ThemContext
    const [anchorEl, setAnchorEl] = useState(null);
    //const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
    const [userInitials, setUserInitials] = useState("");

    useEffect(() => {
        // Extract user name from localStorage and get initials
        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (storedUser && storedUser.name) {
            const initials = storedUser.name
                .split(" ")
                .map((n) => n[0])
                .join("")
                .toUpperCase();
            setUserInitials(initials);
        }

        // Apply theme settings
        document.body.style.background =
            theme === "dark"
                ? "linear-gradient(135deg, #6e7864, #53574f)"
                : "linear-gradient(135deg, #d3d7cf, #e4e7e1)";
        document.body.style.color = theme === "dark" ? "#fff" : "#000";
    }, [theme]);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        console.log("Logging out..."); // Debugging
        localStorage.removeItem("token"); // Clear token
        localStorage.removeItem("user");
    
        //setToken(null); // Update state immediately
        window.location.href = "/login"; // Force redirect to login
    };



    return (
        <Box sx={{ display: "flex" }}>
            {/* Sidebar */}
            <Drawer
    variant="permanent"
    sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
            width: drawerWidth,
            background: "linear-gradient(135deg, #6e7864, #53574f)",
            color: "#ffffff",
            borderRight: "1px solid rgba(255, 255, 255, 0.2)",
            overflowX: "hidden",  // ✅ Fixes right-left scrollbar issue
        },
    }}
>
    <Sidebar />
</Drawer>

            {/* Main Content Wrapper */}
            <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", width: `calc(100% - ${drawerWidth}px)` }}>
                {/* Top Bar */}
                <AppBar position="fixed" sx={{ background: "linear-gradient(135deg, #6e7864, #53574f)", zIndex: 1300, height: "64px" }}>
                    <Toolbar>
                        <img src={Logo} alt="NuGreen Logo" style={{ height: "40px", marginRight: "25px" }} />
                        <Typography variant="h6" sx={{ flexGrow: 1 }}>
                            Partner Portal
                        </Typography>
                        <IconButton onClick={handleMenuOpen} color="inherit">
                            <Avatar>{userInitials || "?"}</Avatar> {/* Show initials or "?" if no name */}
                        </IconButton>
                        <Menu
    anchorEl={anchorEl}
    open={Boolean(anchorEl)}
    onClose={handleMenuClose}
    sx={{
        "& .MuiPaper-root": {
            background: theme === "dark" ? "#3C3F3A" : "#FFFFFF", // Dark or Light mode background
            color: theme === "dark" ? "#E0E0E0" : "#1C1C1C", // Text color
            boxShadow: theme === "dark"
                ? "0px 4px 10px rgba(0, 0, 0, 0.5)" // Dark mode shadow
                : "0px 2px 5px rgba(0, 0, 0, 0.1)", // Light mode shadow
        },
    }}
>
    <MenuItem 
        onClick={toggleTheme}
        sx={{
            "&:hover": {
                background: theme === "dark" ? "#52574E" : "#F0F0F0", // Themed hover effect
            }
        }}
    >
        {theme === "light" ? <Brightness4Icon sx={{ marginRight: 1 }} /> : <Brightness7Icon sx={{ marginRight: 1 }} />}
        {theme === "light" ? "Dark Mode" : "Light Mode"}
    </MenuItem>

    <MenuItem 
        component={Link} 
        
        onClick={handleMenuClose}
        sx={{
            "&:hover": {
                background: theme === "dark" ? "#52574E" : "#F0F0F0", // Themed hover effect
            }
        }}
    >
        <AccountCircleIcon sx={{ marginRight: 1 }} /> Profile
    </MenuItem>

    <MenuItem 
        onClick={handleLogout} 
        sx={{
            "&:hover": {
                background: theme === "dark" ? "#A14B4B" : "#F8D7DA", // Red hover effect for logout
            }
        }}
    >
        <LogoutIcon sx={{ marginRight: 1 }} /> Logout
    </MenuItem>
</Menu>

                    </Toolbar>
                </AppBar>

                {/* Push content down so it's not hidden under the AppBar */}
                <Toolbar />

                {/* Main Content - Now Uses Theme-Based Background */}
                <Box
                    sx={{
                        flexGrow: 1,
                        padding: "20px",
                        background: theme === "dark"
                            ? "linear-gradient(135deg, #6e7864, #53574f)"
                            : "linear-gradient(135deg, #d3d7cf, #e4e7e1)",
                        color: theme === "dark" ? "#fff" : "#000",
                        minHeight: "100vh",
                    }}
                >
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;
